import Proxy from './Proxy';

class ReportsProxy extends Proxy {
  /**
   * The constructor for the ReportsProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/Patients', parameters);
  }

  /**
   * Method used to fetch Reports list.
   *
   * @param {Object} data data to fetch reports enrolled list
   *
   * @returns {Promise} The result in a promise.
   */
  fetchReportsEnrolled(data) {
    return this.submit('post', `${this.endpoint}/reports`, data);
  }


  /**
   * Method used to fetch all patient list.
   *
   * @param {Object} data data to fetch all patient list
   *
   * @returns {Promise} The result in a promise.
   */
  fetchAllPatient(data){
    return this.submit('post', `${this.endpoint}/all`, data);
  }


  /**
   * Method used to fetch  patient report by id.
   *
   * @param {Object} data data to patient report
   *
   * @returns {Promise} The result in a promise.
   */
  fetchPatientReportBasedOnSelection(id,selection,startedate,enddate) {
    return this.submit('get', `${this.endpoint}/${id}/adheranceReport/${startedate}/${enddate}/${selection}`);
  }

  
}

export default ReportsProxy;
